import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../http-client/http-client.service";

import { SmartIdAuthTransactionConfigService } from "./smart-id-auth-transaction.config";
import {
	SmartIdAuthTransactionRequest,
	SmartIdAuthTransactionResponse,
	SmartIdVerificationRequest,
	SmartIdVerificationStatusRequest,
	SmartIdVerificationStatusResponse,
} from "./smart-id-auth-transaction.model";

@Injectable({
	providedIn: "root",
})
export class SmartIdAuthTransactionService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: SmartIdAuthTransactionConfigService
	) {}

	getStatus(request: SmartIdVerificationStatusRequest): Observable<SmartIdVerificationStatusResponse> {
		return this.httpClient.get<SmartIdVerificationStatusResponse>({
			url: this.config.getVerificationStatusEndpoint(),
			searchParams: request,
		});
	}

	initializeVerification(request: SmartIdVerificationRequest): Observable<SmartIdAuthTransactionResponse> {
		return this.httpClient.post<SmartIdAuthTransactionResponse>({
			url: this.config.getVerificationEndpoint(),
			data: request,
		});
	}

	initializeAuthTransaction(request?: SmartIdAuthTransactionRequest): Observable<SmartIdAuthTransactionResponse> {
		return this.httpClient.post<SmartIdAuthTransactionResponse>({
			url: this.config.getVerificationEndpoint(),
			data: request,
		});
	}
}
